import React, { Component, useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import SiteNav from "@/components/SiteNav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Experience from "@/components/Experience";
import Portfolio from "@/components/Portfolio";
import Contact from "@/components/Contact";
import SiteFooter from "@/components/SiteFooter";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="grid min-h-screen place-items-center bg-[#FBF9F5] px-6">
                    <p className="font-serif text-2xl text-[#141413]">
                        Something went wrong — please refresh.
                    </p>
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });
        window.__lenis = lenis;
        let raf = requestAnimationFrame(function loop(time) {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        });
        const onClick = (e) => {
            const a = e.target.closest('a[href^="#"]');
            if (!a) return;
            const id = a.getAttribute("href");
            if (id.length < 2) return;
            const el = document.querySelector(id);
            if (el) {
                e.preventDefault();
                lenis.scrollTo(el, { offset: -72 });
            }
        };
        document.addEventListener("click", onClick);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            document.removeEventListener("click", onClick);
        };
    }, []);

    return (
        <div className="relative min-h-screen bg-[#FBF9F5] text-[#141413]">
            <div className="grain" aria-hidden="true" />
            <SiteNav />
            <main>
                <Hero />
                <Marquee />
                <About />
                <Experience />
                <Portfolio />
                <Contact />
            </main>
            <SiteFooter />
            <Toaster position="bottom-center" />
        </div>
    );
}

export default App;
